import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import _get from 'lodash/get'
import _filter from 'lodash/filter'
import { connect } from 'react-redux'

import Notifications from './../_library/notifications/Notifications'
import { getTitle } from '../utils/getTitle'
import { getConfig } from '../utils/configUtils'
import EventListNew from './HomePage/EventsList'
import { FETCH_BRANDS } from '../../_common/redux/brands/actions'
import { FETCH_EVENTS_INCREMENTAL } from '../../_common/redux/events/actions'
import { get_brands } from '../../_common/core/selectors'

// --- CSS for transition ---
const transitionStyles = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .manage_events.prompt .tab_label .type,
  .manage_events.prompt .tab_label .description,
  .manage_events.prompt .tab_content button span,
  .manage_brands.prompt .tab_label .type,
  .manage_brands.prompt .tab_label .description,
  .manage_brands.prompt .tab_content button span {
    /* Apply the animation when the prompt class is active */
    animation: fadeIn 0.5s ease-in-out;
  }
`

const HomePage = React.memo(props => {
  const {
    displayName,
    configs,
    history: { push },
    brands,
    events,
    FETCH_BRANDS,
    FETCH_EVENTS_INCREMENTAL,
    brandsLoading,
    eventsLoading,
    user,
    eventsInitial,
    brandsInitial,
  } = props

  useEffect(() => {
    const configDocTitle = _get(configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle)
    if (brandsInitial && !brandsLoading) {
      FETCH_BRANDS({ limit: 1, retrieve_with_permissions: 1 })
    }
  }, [
    FETCH_BRANDS,
    FETCH_EVENTS_INCREMENTAL,
    brands,
    events,
    brandsLoading,
    eventsLoading,
    eventsInitial,
    brandsInitial,
    configs,
  ])

  const redirectTo = _get(configs, 'behavior.redirectTo', '')

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  const goTo = (e, link, state = {}) => {
    e.stopPropagation()
    push(link, state)
  }

  const { domain } = getConfig()['*']
  const isTTF = domain === 'ttf'

  const dataReady = !brandsInitial && !eventsInitial
  const hasBrands = dataReady && brands && brands.length > 0
  const adminEvents =
    dataReady && events
      ? _filter(events, event => {
          const permission = _get(event, 'self.role', '')
          return permission === 'admin' || permission === 'owner' || user?.tfStaff
        })
      : []
  const hasAdminEvents = dataReady && adminEvents.length > 0

  const showCreateEventPrompt = dataReady && !hasAdminEvents
  const showCreateBrandPrompt = dataReady && !hasBrands

  return (
    <div className="body-main">
      {/* Inject the styles */}
      <style>{transitionStyles}</style>
      <Notifications />
      <div className="res" />
      <div className="text-center">
        <h2 style={{ color: 'white' }}>
          Welcome to <strong>TICKET</strong>FAIRY
        </h2>
        <h4>Welcome{displayName ? `, ${displayName}` : ''}! What would you like to do today?</h4>
        <div className="accordion">
          <div className="accordion-flex-container">
            <div
              aria-hidden
              className={`manage_events ${showCreateEventPrompt ? 'prompt' : ''}`}
              onClick={e => goTo(e, showCreateEventPrompt ? '/events/new' : '/events')}
            >
              <div className="tab_icon">
                <img alt="Manage Events icon" src={asset('/resources/images/icon-main-event.png')} />
              </div>
              <div className="tab_content">
                <div className="tab_label">
                  <div className="type">
                    {showCreateEventPrompt ? 'Create Your First Event' : 'Manage Events'}
                  </div>
                  <div className="description">
                    {showCreateEventPrompt
                      ? 'Get started by setting up your first event.'
                      : 'Create and manage your events'}
                  </div>
                </div>
                <button
                  type="button"
                  aria-hidden
                  className="btn btn-success"
                  onClick={e => goTo(e, '/events/new')}
                  style={{ backgroundColor: 'transparent' }}
                >
                  <img alt="Add icon" src={asset('/resources/images/btn-add.png')} />
                  {/* Wrap button text in span for animation target */}
                  <span>{showCreateEventPrompt ? 'Create Event' : 'Create New Event'}</span>
                </button>
              </div>
            </div>

            <div
              aria-hidden
              className={`manage_brands ${showCreateBrandPrompt ? 'prompt' : ''}`}
              onClick={e =>
                goTo(
                  e,
                  showCreateBrandPrompt ? (isTTF ? '/brand/new' : '/brands/new') : '/brands',
                  showCreateBrandPrompt ? { createBrandOnly: true } : {},
                )
              }
            >
              <div className="tab_icon">
                <img alt="Manage Brands icon" src={asset('/resources/images/icon-main-brand.png')} />
              </div>
              <div className="tab_content">
                <div className="tab_label">
                  <div className="type">
                    {showCreateBrandPrompt ? 'Create Your First Brand' : 'Manage Brands'}
                  </div>
                  <div className="description">
                    {showCreateBrandPrompt
                      ? 'Set up your brand profile to begin.'
                      : 'Create and manage your brands'}
                  </div>
                </div>
                <button
                  type="button"
                  aria-hidden
                  className="btn btn-success"
                  onClick={e => goTo(e, isTTF ? '/brand/new' : '/brands/new', { createBrandOnly: true })}
                  style={{ backgroundColor: 'transparent' }}
                >
                  <img alt="Add icon" src={asset('/resources/images/btn-add.png')} />
                  {/* Wrap button text in span for animation target */}
                  <span>{showCreateBrandPrompt ? 'Create Brand' : 'Create New Brand'}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <EventListNew />
      </div>
    </div>
  )
})

export default connect(
  state => ({
    displayName: _get(state.auth, 'user.firstName', ''),
    user: state.auth.user,
    brands: get_brands(state) || null,
    brandsInitial: state.brands.brandsInitial,
    events: state.events.events || null,
    eventsInitial: state.events.initial,
    brandsLoading: state.loading.has('FETCH_BRANDS'),
    eventsLoading: state.loading.has('FETCH_EVENTS_INCREMENTAL'),
  }),
  { FETCH_BRANDS, FETCH_EVENTS_INCREMENTAL },
)(HomePage)
